import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  if (compact) {
    return <span className="font-mono font-bold text-sm" data-id="element-67">
        {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-68">
      <ClockIcon className="w-5 h-5 md:w-6 md:h-6 text-brand-pink-600" data-id="element-69" />
      <div className="flex gap-1 md:gap-2" data-id="element-70">
        <div className="bg-gray-900 text-white px-2 md:px-3 py-1 md:py-2 rounded font-mono font-bold text-lg md:text-2xl" data-id="element-71">
          {pad(timeLeft.hours)}
        </div>
        <span className="text-xl md:text-3xl font-bold" data-id="element-72">:</span>
        <div className="bg-gray-900 text-white px-2 md:px-3 py-1 md:py-2 rounded font-mono font-bold text-lg md:text-2xl" data-id="element-73">
          {pad(timeLeft.minutes)}
        </div>
        <span className="text-xl md:text-3xl font-bold" data-id="element-74">:</span>
        <div className="bg-gray-900 text-white px-2 md:px-3 py-1 md:py-2 rounded font-mono font-bold text-lg md:text-2xl" data-id="element-75">
          {pad(timeLeft.seconds)}
        </div>
      </div>
    </div>;
}